const DownIconSVG = ({ className = "", stroke = "#0C6ED1" }) => {
  return (
    <svg
      className={className}
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49219 0.979004L5.53455 5.02111L9.57666 0.979004"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DownIconSVG;
